module.exports = __webpack_public_path__ + "static/insurance-payment-desktop-09f7d5b5ee53d04d5c50203a2c8e79f1.pdf";